import React from 'react'

interface Size {
  bottom: number
  left: number
  right: number
  top: number
  height: number
  width: number
  offsetHeight: number
  offsetWidth: number
  x: number
  y: number
}

export const useSize = <T extends HTMLElement>(
  ref: React.MutableRefObject<T | null>,
): Size => {
  const [size, setSize] = React.useState<Size>({
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    height: 0,
    width: 0,
    offsetHeight: 0,
    offsetWidth: 0,
    x: 0,
    y: 0,
  })

  const set = React.useCallback(() => {
    if (!ref.current) return

    const rect = ref.current.getBoundingClientRect()

    setSize({
      bottom: rect.bottom,
      height: rect.height,
      left: rect.left,
      right: rect.right,
      top: rect.top,
      width: rect.width,
      x: rect.x,
      y: rect.y,
      offsetHeight: ref.current.offsetHeight,
      offsetWidth: ref.current.offsetWidth,
    })
  }, [ref])

  React.useEffect(() => {
    set()
    window.addEventListener('resize', set)
    return () => window.removeEventListener('resize', set)
  }, [ref, set])

  return size
}
